import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Community.css';

const Community = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/open-source-projects')
      .then((res) => setProjects(Array.isArray(res.data) ? res.data : []))
      .catch(() => setProjects([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="community-container fade-in">
      <div className="page-header">
        <h1 className="page-title">
          <span className="gradient-text">开源社区</span>
        </h1>
        <p className="page-subtitle">
          ComfyUI 节点、扩展与工具 · 来自 <a href="https://github.com/MechaBabyAi" target="_blank" rel="noopener noreferrer" className="github-link">GitHub @MechaBabyAi</a>
        </p>
      </div>

      {loading ? (
        <div className="community-loading">加载中...</div>
      ) : projects.length === 0 ? (
        <div className="community-empty">
          <p>暂无开源项目，敬请期待</p>
          <a href="https://github.com/MechaBabyAi" target="_blank" rel="noopener noreferrer" className="community-github-btn">
            访问 GitHub 主页
          </a>
        </div>
      ) : (
        <div className="community-grid">
          {projects.map((project) => (
            <article key={project.id} className="project-card">
              <div className="project-header">
                <h2 className="project-name">{project.name}</h2>
                {project.category && (
                  <span className="project-category">{project.category}</span>
                )}
              </div>
              {project.description && (
                <p className="project-description">{project.description}</p>
              )}
              <div className="project-actions">
                <a
                  href={project.repo_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-btn project-btn-primary"
                >
                  前往仓库
                </a>
                {project.download_url && (
                  <a
                    href={project.download_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-btn project-btn-secondary"
                  >
                    下载 / 安装
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
};

export default Community;
